(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  class TestimonialSlider {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('.testimonials-inner');
      this.cards = Array.from(section.querySelectorAll('.testimonial-card'));
      this.prevBtn = section.querySelector('.prev-btn');
      this.nextBtn = section.querySelector('.next-btn');
      this.pagination = section.querySelector('.pagination');
      this.currentIndex = 0;
      this.isTransitioning = false;
      this.autoplayInterval = null;
      this.cardsPerView = this.getCardsPerView();
      
      this.init();
    }

    getCardsPerView() {
      const width = window.innerWidth;
      if (width <= 480) return 1;
      if (width <= 768) return 2;
      return 3;
    }

    init() {
      if (this.cards.length === 0) return;
      
      // Clone cards for infinite loop
      this.cloneCards();
      this.createPagination();
      this.addEventListeners();
      this.updateSlider(false);
      this.startAutoplay();
    }

    cloneCards() {
      const cloneCount = this.cardsPerView;
      
      // Clone first cards and append to end
      for (let i = 0; i < cloneCount; i++) {
        const clone = this.cards[i].cloneNode(true);
        clone.classList.add('clone');
        this.track.appendChild(clone);
      }
      
      // Clone last cards and prepend to beginning
      for (let i = this.cards.length - 1; i >= this.cards.length - cloneCount; i--) {
        const clone = this.cards[i].cloneNode(true);
        clone.classList.add('clone');
        this.track.insertBefore(clone, this.track.firstChild);
      }
      
      // Update current index to account for prepended clones
      this.currentIndex = cloneCount;
    }

    createPagination() {
      this.pagination.innerHTML = '';
      const totalDots = this.cards.length;
      
      for (let i = 0; i < totalDots; i++) {
        const dot = document.createElement('button');
        dot.classList.add('pagination-dot');
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        if (i === 0) dot.classList.add('active');
        dot.addEventListener('click', () => this.goToSlide(i));
        this.pagination.appendChild(dot);
      }
    }

    addEventListeners() {
      this.prevBtn.addEventListener('click', () => this.prev());
      this.nextBtn.addEventListener('click', () => this.next());
      
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const newCardsPerView = this.getCardsPerView();
          if (newCardsPerView !== this.cardsPerView) {
            this.cardsPerView = newCardsPerView;
            this.reset();
          }
        }, 250);
      });

      this.section.addEventListener('mouseenter', () => this.stopAutoplay());
      this.section.addEventListener('mouseleave', () => this.startAutoplay());
      
      this.track.addEventListener('transitionend', () => {
        this.handleTransitionEnd();
      });
    }

    updateSlider(animate = true) {
      const allCards = this.track.querySelectorAll('.testimonial-card');
      const cardWidth = allCards[0].offsetWidth;
      const gap = 20;
      const offset = -this.currentIndex * (cardWidth + gap);
      
      if (!animate) {
        this.track.style.transition = 'none';
      } else {
        this.track.style.transition = 'transform 0.5s ease-in-out';
      }
      
      this.track.style.transform = `translateX(${offset}px)`;
      
      if (!animate) {
        this.track.offsetHeight; // Force reflow
      }
      
      this.updatePagination();
    }

    updatePagination() {
      const dots = this.pagination.querySelectorAll('.pagination-dot');
      const cloneOffset = this.cardsPerView;
      const actualIndex = ((this.currentIndex - cloneOffset) % this.cards.length + this.cards.length) % this.cards.length;
      
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === actualIndex);
      });
    }

    handleTransitionEnd() {
      const allCards = this.track.querySelectorAll('.testimonial-card');
      const cloneOffset = this.cardsPerView;
      
      // If we're at a clone at the end, jump to the real start
      if (this.currentIndex >= allCards.length - cloneOffset) {
        this.currentIndex = cloneOffset;
        this.updateSlider(false);
      }
      
      // If we're at a clone at the beginning, jump to the real end
      if (this.currentIndex < cloneOffset) {
        this.currentIndex = allCards.length - cloneOffset * 2;
        this.updateSlider(false);
      }
      
      this.isTransitioning = false;
    }

    next() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      this.currentIndex++;
      this.updateSlider(true);
      this.resetAutoplay();
      
      // Allow transition to complete
      setTimeout(() => {
        this.isTransitioning = false;
      }, 100);
    }

    prev() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      this.currentIndex--;
      this.updateSlider(true);
      this.resetAutoplay();
      
      // Allow transition to complete
      setTimeout(() => {
        this.isTransitioning = false;
      }, 100);
    }

    goToSlide(index) {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      const cloneOffset = this.cardsPerView;
      this.currentIndex = index + cloneOffset;
      this.updateSlider(true);
      this.resetAutoplay();
      
      // Allow transition to complete
      setTimeout(() => {
        this.isTransitioning = false;
      }, 100);
    }

    reset() {
      // Remove all clones
      this.track.querySelectorAll('.clone').forEach(clone => clone.remove());
      this.currentIndex = 0;
      this.track.style.transition = 'none';
      this.track.style.transform = 'translateX(0)';
      
      // Reinitialize
      this.cloneCards();
      this.createPagination();
      this.updateSlider(false);
    }

    startAutoplay() {
      this.stopAutoplay();
      this.autoplayInterval = setInterval(() => this.next(), 4000);
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }

    resetAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.testimonial-slider-section');
    sliders.forEach(slider => new TestimonialSlider(slider));
  });

  // Handle Shopify theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.testimonial-slider-section');
      if (section) new TestimonialSlider(section);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
